// Skill radar / overview cards (Reports "skills" tab). Prefix: qbj-
// Glass migration: the four card surfaces (radar, overview, grouped, plain) all
// shared one pre-glass treatment (gray hairline border, solid white, a faint
// drop shadow); they move to the shared glass-flat surface used across Reports
// (frosted bg + edge/float shadow stack). Markup is unchanged — styling only.
export const skillGraphStyles = `
  .qbj-root {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
  }

  .qbj-toggle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 1rem;
    row-gap: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
  }

  .qbj-toggle-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 0.5rem;
    cursor: pointer;
  }

  .qbj-section {
    margin-bottom: 2rem;
  }

  .qbj-title-wrapper {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .qbj-title {
    font-weight: 700;
    font-size: var(--fs-lg);
    color: var(--text-primary);
  }

  .qbj-chart-row {
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }

  .qbj-radar-card {
    width: 40%;
    border-radius: var(--rad-catchup-large);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    padding: 1rem;
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  }

  .qbj-overview-card {
    border-radius: var(--rad-catchup-large);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    padding: 1rem;
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qbj-overview-card-wide {
    width: 60%;
  }

  .qbj-overview-card-full {
    width: 100%;
  }

  .qbj-chart-fill {
    width: 100%;
  }

  .qbj-group {
    width: 100%;
    margin-bottom: 2rem;
  }

  .qbj-card-mb {
    border-radius: var(--rad-catchup-large);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    padding: 1rem;
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
    margin-bottom: 1rem;
  }

  .qbj-card {
    border-radius: var(--rad-catchup-large);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    padding: 1rem;
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  }
`;
